import { useContext, useState, useEffect } from "react";
import { EditableContext } from "../../common/EditableContextProvider";
import * as Yup  from 'yup';
import { Formik, ErrorMessage, Form } from "formik";
import FormError from "../../common/FormError";
import {Spin} from "antd";

const FormPaso = () => {
    const { pasos, loading } = useContext(EditableContext);
    const [initialValues, setInitialvalues] = useState(pasos.editPaso);

    useEffect(() => {
        setInitialvalues(pasos.editPaso);
    }, [pasos.editPaso]);

    const validateSchema = Yup.object({
        descripcion: Yup.string()
            .min(3, 'El texto debe tener al menos 3 letras.')
            .max(200, 'El texto es demasiado largo')
            .required('El campo es obligario.'),
    });


    return (
        <div>
            <Formik
                initialValues={initialValues}
                onSubmit={pasos.handle_save_paso}
                validationSchema={validateSchema}
                enableReinitialize={true}
            >
                {
                    (formik) => (
                        <Form>
                            <div className="mb-2">
                                <label className="form-label">
                                    Descripción
                                    <span className="text-danger">(*)</span>
                                </label>
                                <input type="text" className="form-control form-control-sm" 
                                    value={formik.values.descripcion}
                                    onChange={(e) => formik.setFieldValue('descripcion', e.target.value)}
                                />
                                <ErrorMessage name="descripcion" component={FormError} />
                            </div>
                            <div className="mb-2">
                                <label className="form-label">Notificación</label>
                                <input type="text" className="form-control form-control-sm" 
                                    value={formik.values.notificacion}
                                    onChange={(e) => formik.setFieldValue('notificacion', e.target.value)}
                                />
                                <ErrorMessage name="notificacion" component={FormError} />
                            </div>

                            <div className="mb-2 d-flex justify-content-between">
                                <div>
                                    <span className="text-danger">(*) </span>
                                    <u>Campo obligatorio.</u>
                                </div>
                                <button type="submit" className="btn btn-sm btn-light border border-secondary px-4"
                                    disabled={loading}
                                >
                                    {
                                        (loading) ? (
                                            <Spin size="small" />
                                        ) : "Guardar"
                                    }
                                </button>
                            </div>

                        </Form>
                    )
                }
            </Formik>
        </div>
    );
}

export default FormPaso;